module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/home/recharge_i.png";